import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/shared/auth.service';
import { environment } from '../../../../../environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { AdminService } from 'src/app/services/admin/admin.service';
import { DeliveryPlatformService } from 'src/app/services/delivery/delivery-platform.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment'
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

declare var $: any;
@Component({
  selector: 'app-home',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
})

export class OrderComponent implements OnInit {
  showNavBar: boolean;
  public currency = `${environment.currency}`;
  public collectionName = `${environment.x_tenant_code}`;
  public orders;
  public pages;
  public currentPage;
  public selectedStatus = '';
  public selectorActive: number = 0;
  public isDataLoaded: boolean = false;
  public visiblePages: any = [];

  loggedUserRole: any;
  orderDetails: any;
  searchKeyword: any = '';
  franchises: any;
  shops: any;
  selectedTenant: any;
  selectedFranchise: any = null;
  selectedShop: any = null;
  isFilterClicked = false;
  filterAvailability: boolean = false;
  filterSearchAvailability: boolean = true;
  noItemsAvailable: string = 'No orders available.';
  placeholderText: string = 'Search by Order Id, Price, Platform, Customer Name, Email, Contact Number';
  tableConfig: Array<object> = [
    { id: 1, header: 'Order Time', classType: 'tableHeader ' },
    { id: 2, header: 'Order Id', classType: 'tableHeader orderId' },
    { id: 3, header: 'Platform' },
    { id: 4, header: 'Order Item', classType: 'tableHeader' },
    { id: 4, header: 'Brand', classType: 'tableHeader' },
    { id: 5, header: 'Franchise', classType: 'tableHeader' },
    { id: 6, header: 'Outlet', classType: 'tableHeader' },
    { id: 7, header: 'Price', classType: 'tableHeader' },
    { id: 8, header: 'Status', classType: 'tableHeader' },
    { id: 9, header: 'View', classType: 'tableHeader' },
    { id: 10, type: 'User', classType: 'tableHeader' },
  ];

  tableAction: Array<object> = [
    { id: 'view', type: 'View', image: '../../../../../assets/icons/view.svg' },
  ];

  tableInfo: Array<object> = [
    {
      id: 1,
      header: 'created_date_time',
      type: 'String',
      classType: 'tableData',
    },
    {
      id: 2,
      header: 'display_order_id',
      type: 'String',
      classType: 'tableData',
    },
    { id: 3, header: 'platform_logo', type: 'Image', classType: 'td-platform' },
    {
      id: 4,
      header: 'items',
      type: 'Modifier',
      classType: 'td-order tableData',
    },
    { id: 5, header: 'delivery_platform_name', type: 'StringTitleCase', classType: 'tableData' },
    { id: 6, header: 'franchise', type: 'String', classType: 'tableData' },
    { id: 6, header: 'outlet', type: 'String', classType: 'tableData' },
    {
      id: 7,
      header: 'total_amount',
      type: 'Array',
      classType: 'tableData',
      check: function (test) {
        let price = `${environment.currency}` + test;
        return price;
      },
    },
    { id: 8, header: 'status', type: 'String', classType: 'tableData' },
    { id: 9, header: 'viewAction' },
    { id: 10, header: 'buttons', classType: 'btn-td-action' },

  ];

  delayTimes: any = [
    { id: 0, timeZone: '10 Minutes', value: 10 },
    { id: 1, timeZone: '20 Minutes', value: 20 },
    { id: 2, timeZone: '30 Minutes', value: 30 },
    { id: 3, timeZone: '40 Minutes', value: 40 },
    { id: 5, timeZone: '50 Minutes', value: 50 },
    { id: 6, timeZone: '60 Minutes', value: 60 },
  ];
  submitted: boolean = false;
  selectedOrderId: string = ""
  isActionClick: boolean = false;
  isSuccess: boolean = false;
  message: string = "";

  colorTheme = 'theme-dark-blue';
  bsConfig: Partial<BsDatepickerConfig>;
  myDateValue: Date;
  selectedStartDate: string;
  startDate: any = "";
  endDate: any = "";
  orderStatusArr: any = ['ALL', 'CREATED', 'ACCEPTED', 'READY_FOR_PICKUP', 'COMPLETED', 'MISSED', 'DENIED', 'CANCELED'];
  campaignData: any = [];
  selectedCampaign: string = ""
  platformArr: any = ['ALL', 'DELIVEROO', 'UBER_EATS', 'WEBSHOP', 'TABLE_ORDER'];
  selectedPlatform: string = "";

  constructor(
    private authenticationService: AuthenticationService,
    private deliveryService: DeliveryPlatformService,
    private firestore: AngularFirestore,
    private adminService: AdminService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {

    this.spinner.show()
    this.getTenants();
    this.getCurrentUser();
    this.getCampaignData();
    $('.selectpicker').selectpicker('refresh');

    this.getAllFranchises();
    this.bsConfig = Object.assign({}, { containerClass: this.colorTheme });

    if (localStorage.getItem('firebaseListner') == 'Active') {
      this.getData();
    } else {
      this.listenFirebase();
    }
  }

  filterForm: FormGroup = new FormGroup({
    franchise: new FormControl(''),
    shop: new FormControl(''),
  });

  delayForm: FormGroup = new FormGroup({
    time: new FormControl('', Validators.required),
  });

  dateForm: FormGroup = new FormGroup({
    date: new FormControl(''),
  })

  updateDate(newDate) {

    if (newDate) {
      console.log(newDate, 'newDate');

      this.isDataLoaded = false;
      this.selectorActive = 5;
      this.selectedStatus = this.selectedStatus == '' ? 'ALL' : this.selectedStatus;
      this.startDate = moment(newDate[0]).format('YYYY-MM-DD');
      this.endDate = moment(newDate[1]).format('YYYY-MM-DD');
      this.getData();
    }
  }

  public listenFirebase() {
    if (this.authenticationService.getLoggedUser().user_roles.role_id == 4) {

      let firebase_code =
        this.collectionName +
        '_' +
        this.authenticationService.getLoggedUser().outlet_code;
      this.firestore
        .collection(firebase_code)
        .snapshotChanges()
        .subscribe((res) => {
          this.isDataLoaded = false;
          this.getData();
          localStorage.setItem('firebaseListner', 'Active');
        });
    } else {
      this.getData();
    }
  }

  getCurrentUser() {
    this.loggedUserRole =
      this.authenticationService.getLoggedUser().user_roles.role_id;

    if (this.loggedUserRole == 4) {
      this.selectedFranchise =
        this.authenticationService.getLoggedUser().shops[0].franchise_id;
      this.selectedShop =
        this.authenticationService.getLoggedUser().shops[0].id;
    } else if (this.loggedUserRole == 3) {
      this.selectedFranchise =
        this.authenticationService.getLoggedUser().franchises[0].id;
    }

  }

  public open(data) {

    if (data.text != 'Delay') {
      this.isDataLoaded = false;
      this.deliveryService.respondToOrder(data.text, data.id).subscribe((res) => {
        this.getData();
      });
    } else {
      $('#delayModal').modal('show');
      this.selectedOrderId = data.id;
    }

  }

  selectorPressed(selectorId) {
    console.log(selectorId, 'selectorId');

    this.searchKeyword = "";
    this.selectedStatus = this.selectedStatus == '' ? 'ALL' : this.selectedStatus;
    this.dateForm.reset();
    var today = moment().format('YYYY-MM-DD');
    this.selectorActive = selectorId;
    switch (selectorId) {
      case 0: {
        this.isDataLoaded = false;
        this.startDate = "";
        this.endDate = "";
        this.selectedStatus = this.selectedStatus == '' || this.selectedStatus == 'ALL' ? '' : this.selectedStatus;
        this.getData();
      }
        break;
      case 1: {
        console.log(selectorId, 'case 1');
        this.isDataLoaded = false;
        this.startDate = today;
        this.endDate = today;
        this.getData();
      }
        break;
      case 2: {
        this.isDataLoaded = false;
        var yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
        this.startDate = yesterday;
        this.endDate = yesterday;
        this.getData();
      }
        break;
      case 3: {
        this.isDataLoaded = false;
        var last7dasy = moment().subtract(7, 'days').format('YYYY-MM-DD');
        let lastend7days = moment().subtract(1, 'days').format('YYYY-MM-DD');
        this.startDate = last7dasy;
        this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
        this.getData();
      }
        break;
      case 4: {
        this.isDataLoaded = false;
        var lastMonthStartDay = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        var lastMonthEndDay = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
        this.startDate = lastMonthStartDay;
        this.endDate = lastMonthEndDay;
        this.getData();
      }
        break;

      default: console.log('Not Valid')
    }
  }

  public orderByStatus(status) {
    console.log(status, this.selectorActive, 'orderByStatus');

    this.selectedStatus = this.selectorActive == 0 && status == "ALL" ? '' : status;
    this.visiblePages = [];
    this.currentPage = 1;
    this.deliveryService
      .getOrderByStatus(this.selectedStatus, this.selectedFranchise, this.selectedShop, this.startDate, this.endDate, this.searchKeyword, this.selectedCampaign, this.selectedPlatform)
      .subscribe((res) => {
        this.orders = res.data.orders;
        this.getPagesCount(res.data.lastPage);
      });
  }

  public getData() {

    this.visiblePages = [];
    this.currentPage = 1;
    console.log(this.startDate, this.endDate, 'this.startDate, this.endDate,');


    this.deliveryService
      .getAllOrders(this.selectedStatus, this.selectedFranchise, this.selectedShop, this.startDate, this.endDate, this.searchKeyword, this.selectedCampaign, this.selectedPlatform)
      .subscribe((res) => {
        this.orders = res.data.orders;
        this.isDataLoaded = true;
        this.getPagesCount(res.data.lastPage);
        this.currentPage = res.data.currentPage;
      });
  }

  public searchOrders(event: any) {
    console.log('searchOrders');

    this.visiblePages = [];
    this.currentPage = 1;

    if (event.target.value == '') {
      this.searchKeyword = null;
    } else {
      this.searchKeyword = event.target.value;
    }
    this.getData();
    // this.deliveryService
    //   .searchOrders(
    //     this.selectedFranchise,
    //     this.selectedShop,
    //     this.searchKeyword,
    //     null
    //   )
    //   .subscribe((res) => {
    //     this.orders = res.data.orders;
    //     this.getPagesCount(res.data.lastPage);
    //     this.isDataLoaded = true;
    //     this.currentPage = res.data.currentPage;
    //   });
  }

  public getPagesCount(pageCount) {
    let pages = [];
    this.visiblePages = [];
    for (let i = 1; i <= pageCount; i++) {
      pages.push(i);
    }
    this.pages = pages;

    this.pages.slice(0, 5).map((i) => {
      this.visiblePages.push(i);
    });
  }

  public getMoreOrders(pageNumber) {
    if (pageNumber > 5) {
      this.visiblePages = [];

      this.pages.slice(pageNumber - 5, pageNumber).map((i) => {
        this.visiblePages.push(i);
      });
    } else {
      this.visiblePages = [];
      this.pages.slice(0, 5).map((i) => {
        this.visiblePages.push(i);
      });
    }

    this.deliveryService
      .getOrdersPagination(
        this.selectedFranchise,
        this.selectedShop,
        this.selectedStatus,
        pageNumber,
        this.searchKeyword,
        this.startDate,
        this.endDate,
        this.selectedCampaign,
        this.selectedPlatform
      )
      .subscribe((res) => {
        this.isDataLoaded = true;
        this.orders = res.data.orders;
        this.currentPage = res.data.currentPage;
      });


  }

  selectorClicked(selectorId) {
    this.selectorActive = selectorId;
  }

  loadFilters() {
    if (!this.isFilterClicked) {
      this.isFilterClicked = true;
    } else {
      this.isFilterClicked = false;
    }

    $('#spicker_franchise').selectpicker('refresh');
    $('#spicker_franchise').selectpicker('val');


    this.loggedUserRole =
      this.authenticationService.getLoggedUser().user_roles.role_id;
    if (this.loggedUserRole > 2) {
      $('#spicker_shop').removeAttr('disabled');
      $('#spicker_shop').selectpicker('refresh');
    }
  }

  getAllFranchises() {
    this.adminService.getFranchises().subscribe((res) => {
      // console.log(res, 'franchises')
      this.franchises = res.data;
      $('#spicker_shop').selectpicker('refresh');
      $('#spicker_shop').selectpicker('val');
    });
  }

  getTenants() {
    if (this.authenticationService.getLoggedUser() != null) {
      this.adminService.getOutlets().subscribe((res) => {
        this.shops = res.data;
      });
    }
  }

  async selectFranchise(e) {
    this.selectedFranchise = e;
    this.selectedShop = null;
    this.isDataLoaded = true;
    await this.adminService
      .getShopsRelatedFranchise(e)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.shops = res.data;
          this.getData();
          this.isDataLoaded = false;

        },
        error: (error) => this.isDataLoaded = false
      })
    setTimeout(function () {
      $('#spicker_shop').removeAttr('disabled');
      $('#spicker_shop').selectpicker('refresh');
      $('#spicker_shop').selectpicker('val', '');
    }, 1000);
  }

  changeTenant(e) {
  }

  selectShop(e) {
    console.log(e, 'selectShop');

    this.selectedTenant = e.code;
    this.selectedShop = e.id;
    this.getData();
    this.selectorClicked(1);
    this.isDataLoaded = false;

  }


  selectStatus(e) {
    console.log(e, 'selectStatus');
    this.orderByStatus(e);
  }

  selectPlatform(e) {
    console.log(e, 'selectPlatform');
    this.selectedPlatform = e == "ALL" ? '' : e
    this.getData();
  }

  selectCampaign(e) {
    console.log(e, 'selectCampaign');
    this.selectedCampaign = e == "ALL" ? '' : e
    this.getData();
  }

  onCancel() {
    $('#viewDetailsModal').modal('hide');
  }

  onViewClick(data) {
    console.log(data, "oder details")
    this.orderDetails = data;

    $('#viewDetailsModal').modal('show');
  }

  onCancelDelayModal() {
    this.delayForm.reset();
    $('#delayModal').modal('hide');
  }

  onDelayClicked() {

    this.submitted = true

    if (this.delayForm.valid) {
      this.isActionClick = true
      let data = {
        ready_in: this.delayForm.value.time.value,
      };
      this.deliveryService.updateOrderReadyTime(this.selectedOrderId, data)
        .subscribe({
          next: (res) => {
            console.log(res);
            this.isActionClick = false;
            this.isSuccess = true;
            this.message = 'Successfully updated the order ready time!'
            $('#delayModal').modal('hide');
            //this.getData();
          },
          error: (error) => {
            this.isSuccess = false;
            this.message = error
            this.isActionClick = false
          }
        })
    }

  }

  checkDiscountType(orderDetails: any) {
    let discount_type = ''
    switch (orderDetails.discount_type) {
      case 'first_order_offer':
        discount_type = 'First Order Promo'
        break;
      case 'promotion_discount':
        discount_type = 'Promotion Discount'
        break;
      case 'delivery_discount':
        discount_type = 'Delivery Discount'
        break;
      case 'collection_discount':
        discount_type = 'Collection Discount'
        break;
      case 'voucher':
        discount_type = 'Voucher'
        break;
      default:
        discount_type = 'Discount'
        break;
    }

    return discount_type
  }

  public getCampaignData() {

    this.adminService.getCampaignDetails().subscribe({
      next: (res) => {
        this.campaignData = res.data;
      },
      error: (err) => {
        console.error('Error fetching campaign details:', err);
      }
    });
  }
}
